<template>
	<div class="dot-selector flex-centerize">
		<div v-for="(dot, index) in dotArray" :key="index">
			<div class="dot-container">
				<div class="dot" @click="$emit('dotClicked', index)" :class="{ 'is-current': currentDotIndex === index }"></div>
			</div>
		</div>
	</div>
</template>

<script>
// const menuItem = (text, svg, callback, notification) => ({ text, svg, callback, notification });

export default {
	name: 'DotSelector',
	components: {},
	props: {
		dotArray: { type: Array, default: () => [] },
		currentDotIndex: { type: Number },
	},
	computed: {},
	methods: {},
	watch: {},
	mounted() {},
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.dot-selector {
	$size: 7px;

	padding: 4px 0;

	&:hover {
		cursor: pointer;
	}
	.dot-container {
		padding: 8px 5px;

		.dot {
			height: $size;
			width: $size;
			border-radius: 50%;
			background-color: #7e7fe7;
			transition: 0.3s;

			&:hover,
			&.is-current {
				background-color: white;
			}
			&:hover {
				transform: scale(1.6);
				transition: 0.2s;
			}
		}
	}
}
</style>
